import React from "react";
import { Form } from "@ant-design/compatible";
import { Skeleton, message, List, Input, Button, Avatar } from "antd";
import { Comment } from "@ant-design/compatible";
import PageLoader from "./PageLoader";
import { gql, useQuery } from "@apollo/client";
import { client } from "../App";

const MIGRATION_NOTES_QUERY = gql`
  query MigrationNotesQuery($projectId: ID!) {
    project(id: $projectId) {
      notes {
        id
        createdAt
        updatedAt
        deleted
        value
      }
    }
  }
`;

const CREATE_NOTE_MUTATION = gql`
  mutation createNote($projectId: ID!, $value: String!) {
    createNote(projectId: $projectId, value: $value) {
      id
      value
      createdAt
      updatedAt
    }
  }
`;

const DELETE_NOTE_MUTATION = gql`
  mutation deleteNote($id: ID!) {
    deleteNote(id: $id) {
      id
    }
  }
`;

export default function projectNotesTab(project: any) {
  const projectId = project.id;
  return (
    <div>
      <NoteList projectId={projectId} />
      <AddNoteForm projectId={projectId} />
    </div>
  );
}

export function migrationNotesTab(migration: any) {
  const project = migration.project;
  return projectNotesTab(project);
}

async function deleteNote(e) {
  const noteId = e.target.dataset.noteId;
  const projectId = e.target.dataset.projectId;
  client.mutate({
    mutation: DELETE_NOTE_MUTATION,
    variables: { id: noteId },
    refetchQueries: [
      { query: MIGRATION_NOTES_QUERY, variables: { projectId: projectId } },
    ],
  });
}

export const NoteList = ({ projectId }: any) => {
  const { loading, error, data } = useQuery(MIGRATION_NOTES_QUERY, {
    variables: { projectId },
    pollInterval: 5000,
  });

  if (loading) return <PageLoader tip="Loading..." delay={500} />;

  if (error) {
    message.error("Failed to get Notes");
    return <Skeleton />;
  }

  const notes: [] = data.project.notes.filter((note) => note.deleted != true);

  return (
    <List
      dataSource={notes}
      itemLayout="horizontal"
      renderItem={(note: any) => (
        <Comment
          content={note.value}
          datetime={note.updatedAt}
          author="Derek"
          actions={[
            <a
              data-note-id={note.id}
              data-project-id={projectId}
              onClick={deleteNote}
            >
              Delete
            </a>,
          ]}
          avatar={<Avatar src="https://i.stack.imgur.com/2dtUp.png" />}
        />
      )}
    />
  );
};

const TextArea = Input.TextArea;

const Editor = ({ onChange, onSubmit, submitting, value }: any) => (
  <div>
    <Form.Item>
      <TextArea rows={4} onChange={onChange} value={value} />
    </Form.Item>
    <Form.Item>
      <Button
        htmlType="submit"
        loading={submitting}
        onClick={onSubmit}
        type="primary"
      >
        Add Comment
      </Button>
    </Form.Item>
  </div>
);

type AddNoteFormProps = {
  projectId: number | string;
};
export class AddNoteForm extends React.Component<AddNoteFormProps> {
  state = {
    submitting: false,
    value: "",
  };

  handleSubmit = () => {
    if (!this.state.value) {
      return;
    }

    this.setState({
      submitting: true,
    });

    setTimeout(() => {
      client.mutate({
        mutation: CREATE_NOTE_MUTATION,
        variables: { projectId: this.props.projectId, value: this.state.value },
        refetchQueries: [
          {
            query: MIGRATION_NOTES_QUERY,
            variables: {
              projectId: this.props.projectId,
            },
          },
        ],
      });
      this.setState({
        submitting: false,
        value: "",
      });
    }, 1000);
  };

  handleChange = (e: any) => {
    this.setState({
      value: e.target.value,
    });
  };

  render() {
    const { submitting, value } = this.state;

    return (
      <div>
        <Comment
          content={
            <Editor
              onChange={this.handleChange}
              onSubmit={this.handleSubmit}
              submitting={submitting}
              value={value}
            />
          }
        />
      </div>
    );
  }
}
